import { useQuery } from '@tanstack/react-query'

import {
  getEstimateInsuranceForItem,
  type GetEstimateInsuranceForItemOptions,
} from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'

export function useQueryGetEstimateInsuranceForItem({
  options,
  item_internal_id,
}: {
  options: GetEstimateInsuranceForItemOptions
  item_internal_id: ParameterID
}) {
  return useQuery({
    queryKey: ['QueryGetEstimateInsuranceForItem', item_internal_id],
    queryFn: async () =>
      await getEstimateInsuranceForItem(item_internal_id, options),
    enabled: !!item_internal_id,
  })
}
